import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useStockStore = defineStore('stock', () => {
  const currentCode = ref('')
  const currentName = ref('')

  function setStock(code, name) {
    currentCode.value = code
    currentName.value = name
  }

  return { currentCode, currentName, setStock }
})
